import React, { useEffect, useState } from 'react';
import styles from "../../etc/innerheader.module.css";
import { useHistory } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { ReactComponent as ArrowLeftLight} from "../../../../src/svg/arrow-left-light.svg";
import { set } from 'lodash';

const CoachingHeader: React.FC<any> = (props) => {

    const [platform, setPlatform] = useState("");
    const history = useHistory();
    const [currentStatus, setCurrentStatus] = useState(-1);

    //플랫폼 정보 확인
    useEffect(() => {
        const platform = Capacitor.getPlatform();

        if (platform) {
            setPlatform(platform);
        }

    }, []);

    const handleClick = (e: any) => {
        if (props.home) {
            history.push("/mobiledashboard");
        } else {
            history.goBack();
        }
    }

    useEffect(() => {

        console.log("CoachingHeader props.currentStatus: ", props.currentStatus);

        setCurrentStatus(props.currentStatus);

    }, [props.currentStatus]);

    return (
        <div style={{
            paddingTop: "env(safe-area-inset-top)"
        }}>
            <div className={`${styles.header} ${platform === "ios" ? styles.ios : ""}`} ref={props.headerRef}>
                <div
                    onClick={(e: any) => { handleClick(e) }}
                    style={{
                        width : "30px"
                    }}
                >
                    <ArrowLeftLight
                        className={styles.arrowLeft}
                    />
                </div>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    {
                        currentStatus !== - 1 ?
                        [1, undefined, 2, undefined, 3].map((item, index) => {
                            if (item) {
                                return (
                                    <div key={index} style={{
                                        width : "2rem",
                                        height : "2rem",
                                        borderRadius : "50%",
                                        display : "flex",
                                        alignItems : "center",
                                        justifyContent : "center",
                                        fontFamily : "Apple_R",
                                        backgroundColor : currentStatus * 2 > index ? "#1b49af" : "#e8e8e8",
                                        color : currentStatus * 2 > index ? "#ffffff" : "black",
                                    }}>
                                        {item}
                                    </div>
                                )
                            } else {
                                return (
                                    <div key={index} style={{
                                        width : "0.6rem",
                                        height : "0.1rem",
                                        backgroundColor : "#d8d8d8",
                                        marginLeft : "0.25rem",
                                        marginRight : "0.25rem",
                                    }}>
                                    </div>
                                )
                            }
                        })
                        :
                        ""
                    }
                </div>
                <div style={{
                    width : "30px",
                }}>
                    
                </div>
            </div>
        </div>
    )
}

export default CoachingHeader;